import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import UcWindow from '../../UcWindow';
import { getPopupPosition } from "../../../lib/utils/styling";
import { getFitDataLayout } from "../../../lib/utils";
import { cloneDeep } from "lodash-es";
import DEFAULT_COMPONENT_ICON from '../../assets/defaultComponentIcon.png';
import Alternates from "./Alternates";
import { invokeFitDataOnApply } from '../../designer/utils/invokeCallbacks';
const __script_base__ = {
  name: 'AlternateComponents',
  components: {
    UcWindow,
    Alternates
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  computed: {
    width() {
      var _this$value$layouts;
      return this.maxWidth * (((_this$value$layouts = this.value.layouts) === null || _this$value$layouts === void 0 ? void 0 : _this$value$layouts.length) || this.maxItemNumber);
    }
  },
  data() {
    return {
      left: '0px',
      top: '0px',
      shown: false,
      title: '',
      compPath: '',
      dataPath: '',
      value: null,
      dragTitle: '',
      dragSource: null,
      defaultIcon: DEFAULT_COMPONENT_ICON,
      maxWidth: 170,
      maxItemNumber: 3
    };
  },
  methods: {
    openWindow(options) {
      const height = parseInt(this.height, 10);
      this.title = options.title;
      const position = getPopupPosition({
        anchor: options.place,
        container: this.designer.$el,
        // width,
        height
      });
      this.left = `${position.x}px`;
      this.top = `${position.y}px`;
      this.compPath = options.compPath;
      this.dataPath = options.dataPath;
      this.value = options.getAlternates();
      this.dragTitle = options.dragTitle;
      this.dragSource = options.dragSource;
      this.title = options.title;
      this.shown = true;
    },
    async applyAlternate([item, entityParams]) {
      if (!('layout' in item)) {
        var _layouts$;
        if (!('layouts' in item)) return;
        const {
          layouts
        } = getFitDataLayout(item);
        // eslint-disable-next-line no-param-reassign
        item = {
          ...item,
          layout: (_layouts$ = layouts[0]) === null || _layouts$ === void 0 ? void 0 : _layouts$.layout
        };
      }
      const layout = cloneDeep(item.layout);
      this.uc.completeLayout(layout);
      this.designer.replaceCompWith(this.compPath, layout);
      this.uc.notifyPageletsChange(0);
      this.$nextTick(() => {
        invokeFitDataOnApply({
          scene: 'replace',
          uc: this.uc,
          designer: this.designer,
          renderer: this.designer.renderer,
          compPath: this.designer.compPath,
          entityParams
        }, item);
      });
    }
  },
  created() {
    // 切换子页面片，需要隐藏这个窗口！！！
    this.$watch(() => this.designer.renderer, () => {
      this.shown = false;
    });
    // 在当前窗口可见的情况下，如果选中了其他组件，要隐藏这个窗口
    this.$watch(() => this.shown && this.compPath !== this.designer.compPath, needClosing => {
      if (needClosing) this.shown = false;
    });
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("uc-window", {
    attrs: {
      left: _vm.left,
      top: _vm.top,
      title: _vm.title,
      visible: _vm.shown
    },
    on: {
      "update:visible": function ($event) {
        _vm.shown = $event;
      }
    }
  }, [_c("Alternates", {
    attrs: {
      "data-path": _vm.dataPath,
      value: _vm.value,
      "drag-title": _vm.dragTitle,
      "drag-source": _vm.dragSource
    },
    on: {
      switch: _vm.applyAlternate,
      dragend: function ($event) {
        _vm.shown = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/AlternateComponents/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);